// Premium scroll-reveal: fades/lifts key content into place as it scrolls in.
// Built to fail safe so the page can never be left blank:
// - anything already on screen at load is shown immediately (no hide/fade),
// - elements are revealed a little before they enter the viewport,
// - a fallback timer reveals everything that hasn't been revealed yet,
// - pages restored from the back/forward cache are shown straight away.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.keo-section-heading',
    '.keo-page-hero__title',
    '.keo-coll-hero__title',
    '.keo-cat-tile',
    '.keo-product-card',
    '.keo-review-card',
    '.keo-video-card',
    '.keo-reel',
    '.keo-ugc-tile',
    '.keo-journal__card',
    '.keo-split__media',
    '.keo-split__text',
    '.keo-love__row',
    '.keo-principles__item',
    '.keo-trust__item',
    '.keo-cts__item'
  ].join(',');

  var observer = null;
  var watchdog = null;

  function reveal(el) {
    el.classList.add('keo-reveal--visible');
    if (observer) observer.unobserve(el);
  }

  function revealAll() {
    document.querySelectorAll('.keo-reveal:not(.keo-reveal--visible)').forEach(reveal);
  }

  // Reveals anything that is on screen but still hidden (observer missed it).
  function revealStuck() {
    var viewportH = window.innerHeight || document.documentElement.clientHeight;
    var pending = document.querySelectorAll('.keo-reveal:not(.keo-reveal--visible)');
    if (!pending.length) { clearInterval(watchdog); watchdog = null; return; }
    pending.forEach(function (el) {
      if (el.getBoundingClientRect().top < viewportH) reveal(el);
    });
  }

  function init(root) {
    var scope = root || document;
    var viewportH = window.innerHeight || document.documentElement.clientHeight;
    var els = Array.prototype.filter.call(scope.querySelectorAll(SELECTORS), function (el) {
      if (el.classList.contains('keo-reveal')) return false;
      // Leave anything already on (or just above) screen alone: it must
      // never blink out on load.
      var r = el.getBoundingClientRect();
      return r.top > viewportH * 0.9;
    });
    if (!els.length) return;

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        var n = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.style.transitionDelay = (n++ % 4) * 40 + 'ms';
          reveal(el);
        });
      }, { threshold: 0, rootMargin: '0px 0px 40% 0px' });
    }

    els.forEach(function (el) {
      el.classList.add('keo-reveal');
      observer.observe(el);
    });

    // Safety net: if the observer is throttled or misses an element (fast
    // scroll, unusual scroll container, browser quirk) rescue anything on
    // screen that is still hidden. Stops itself once everything is shown.
    if (!watchdog) watchdog = setInterval(revealStuck, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) revealAll(); });
  // Layout changes (desktop/mobile switch, rotation): show anything now on
  // screen straight away rather than waiting on the observer.
  var resizeT = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(revealStuck, 200);
  }, { passive: true });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') setTimeout(revealStuck, 300); });
  // Theme editor re-renders sections; never leave edited content hidden.
  document.addEventListener('shopify:section:load', function () { revealAll(); });
  document.addEventListener('shopify:section:select', function () { revealAll(); });
})();
